import Axios from "axios";
import { LOGOUT_DELIVERY_USER } from "./user/actionTypes";

export const deliveryAuthHeaders = (token) =>
	token ? { Authorization: `Bearer ${token}` } : {};

export const deliveryAuthBody = (token, data = {}) =>
	token ? { ...data, token } : data;

export const appendDeliveryAuthToken = (token, payload) => {
	if (!token) {
		return payload;
	}

	if (payload instanceof FormData) {
		if (!payload.has("token")) {
			payload.append("token", token);
		}
		return payload;
	}

	return deliveryAuthBody(token, payload);
};

let boundStore = null;
let interceptorInstalled = false;

export const bindDeliveryAuthStore = (store) => {
	boundStore = store;
};

const isDeliveryApiUrl = (url = "") =>
	typeof url === "string" && /\/delivery\//.test(url);

/**
 * Some delivery endpoints historically return 401 for business cases
 * (e.g. cancelled / missing orders). Only clear session for real auth failures.
 */
const isAuthSessionFailure = (error) => {
	const status = error?.response?.status;
	if (status !== 401) {
		return false;
	}

	const msg = String(
		error?.response?.data?.message ||
			error?.response?.data?.data ||
			""
	).toLowerCase();

	if (
		msg.includes("order cancelled") ||
		msg.includes("not found") ||
		msg.includes("already taken")
	) {
		return false;
	}

	return true;
};

export const installDeliveryAuthInterceptor = () => {
	if (interceptorInstalled) {
		return;
	}
	interceptorInstalled = true;

	Axios.interceptors.response.use(
		(response) => response,
		(error) => {
			const url = error?.config?.url || "";
			if (boundStore && isDeliveryApiUrl(url) && isAuthSessionFailure(error)) {
				try {
					localStorage.removeItem("authToken");
					boundStore.dispatch({
						type: LOGOUT_DELIVERY_USER,
						payload: [],
					});
				} catch (_err) {
					// ignore dispatch/storage failures
				}
			}
			return Promise.reject(error);
		}
	);
};

/** Prefer API message, then first Laravel validation error. */
export const firstDeliveryApiErrorMessage = (body) => {
	if (!body || typeof body !== "object") {
		return "";
	}
	if (typeof body.message === "string" && body.message.trim()) {
		return body.message.trim();
	}
	if (body.errors && typeof body.errors === "object") {
		const first = Object.values(body.errors)
			.flat()
			.find((item) => typeof item === "string" && item.trim());
		if (first) {
			return first.trim();
		}
	}
	if (typeof body.data === "string" && body.data.trim()) {
		return body.data.trim();
	}
	if (typeof body.error === "string" && body.error.trim()) {
		return body.error.trim();
	}
	return "";
};
